import React from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ResponsivePage } from "../../../components/desktopUi";
import { MenuCard, MenuGrid } from "../../../components/managementUi";
import { appImages } from "../../../assets/appicons";
import { useEmployeeAuth } from "../../../auth/EmployeeAuthContext";
import { JOB_TITLE, isSupportDepartment } from "../../../utils/managerRole";
import { EMP_BASE_PATH } from "../../../config";

// Khớp app: KPI khối chỉ dành cho Giám đốc, Trưởng vùng và 3 phòng ban đặc biệt.
const DIRECTOR_JOB_CODES = [JOB_TITLE.TGD, JOB_TITLE.PTGD, JOB_TITLE.GDCN];

const ReportIndex = () => {
  const navigate = useNavigate();
  const { user } = useEmployeeAuth();
  const jobPosition = user?.jobPosition?.code || "";
  const canViewBlockKpi =
    isSupportDepartment(user?.supportDepartment?.code) ||
    jobPosition === JOB_TITLE.TRUONG_VUNG ||
    DIRECTOR_JOB_CODES.includes(jobPosition);

  return (
    <ResponsivePage title="Báo cáo thống kê">
      <MenuGrid>
        <MenuCard
          icon={appImages.icon_khach_hang}
          label="KPI nhân viên khối kinh doanh"
          onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/bao-cao/kpi-nhan-vien`)}
        />
        {canViewBlockKpi && (
          <MenuCard
            icon={appImages.icon_QLNV}
            label="KPI khối"
            onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/bao-cao/kpi-khoi`)}
          />
        )}
      </MenuGrid>
    </ResponsivePage>
  );
};

export default ReportIndex;
